/* eslint-disable camelcase */
import { pushToDataLayer } from '../pushToDataLayer';

function clickOnArticleLink() {
	$('.ga-article-link').on('click', event => {
		pushToDataLayer({
			event: 'engagement',
			action: 'article-read',
			url: event.currentTarget.href
		});
	});
}

function clickOnPreferredSource() {
	$('.js-preferred-source').on('preferred-source-click', event => {
		const component = event.currentTarget;
		pushToDataLayer({
			event: 'preferred_source_click',
			page_location: window.location.href,
			page_title: document.title,
			page_type: component.getAttribute('data-page-type'),
			brand: component.getAttribute('data-brand'),
			market: component.getAttribute('data-market')
		});
	});
}

export const addArticleListeners = () => {
	clickOnArticleLink();
	clickOnPreferredSource();
};
